import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LearnexService {

  constructor(private http: HttpClient) { }
  
  getLearnex(apexId:string, language:string): Observable<any> {
    
    // {{dmp_api_d}}/v1.0/learnex?apexid=zhangpy&language=1
    let url=`${environment.api.uri}v1.0/learnex?apexid=${apexId}&language=${language}`;
    return this.http.get<any>(url);
  }
  
}
